const toggleInfoShown = () => {
  return { type: "TOGGLE_INFO_SHOWN" };
};

export default toggleInfoShown;
